import { confirmPopup, ConfirmPopupProps } from 'primereact/confirmpopup';
import LanguageUtil from 'util/LanguageUtil';

export const customConfirm = (settings: ConfirmPopupProps) => {
  settings.acceptClassName = 'confirm-popup-accept';
  settings.rejectClassName = 'confirm-popup-reject';
  settings.acceptLabel = LanguageUtil.get({ id: 'common.label.yes', defaultMessage: 'Yes' });
  settings.rejectLabel = LanguageUtil.get({ id: 'common.label.no', defaultMessage: 'No' });
  settings.visible = true;
  confirmPopup(settings);
};
